import React from "react";
import { Box } from "@mui/material";
import DevicePreview, { DeviceForPreview } from "../../preview/DevicePreview";
import { ComponentTemplateDto } from "@growth-machine-llc/stridist-api-client";

const TemplatePreviewTab = ({
  componentTemplate,
}: {
  componentTemplate: ComponentTemplateDto;
}) => {
  return (
    <Box paddingTop={1.5} paddingBottom={0} paddingInline={3}>
      <DevicePreview
        device={DeviceForPreview.IPHONE}
        mode="component"
        customContent={componentTemplate.content}
        component={componentTemplate as any}
        minWidth={275}
      />
    </Box>
  );
};

export default TemplatePreviewTab;
